import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ThoughtBubbleFlowInvocationSchema = withDefaults({
  type: 'thought-bubble-flow-invocation',
  fields: [
    {
      kind: 'attribute',
      name: 'flowId',
    },
    {
      kind: 'attribute',
      name: 'personId',
    },
    {
      kind: 'attribute',
      name: 'stepsCompleted',
    },
    {
      kind: 'attribute',
      name: 'completed',
    },
    {
      kind: 'attribute',
      name: 'browserMeta',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'flow',
      type: 'thought-bubble-flow',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default ThoughtBubbleFlowInvocationSchema;
